import React, { useContext, useMemo, useState } from 'react'
import { AuthContext } from '../../../../../../context/auth.context'
import { useApiFormNodeCourse, useApiListNodeTemplate, useApiListNodeTemplateCategory } from '../../../../../../api-new/state/content'
import { useLoad } from '../../../../../../shared/hooks/load'
import { BreadcrumbView } from '../../../../../../context/breadcrumb.context'
import { IconCopy } from '../../../../../../shared/icon/icon'
import { LoginSysAdmin } from '../../../../../../role/components/login-sys-admin'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { CourseMenu } from '../../common/menu/node-actions'
import { CardFullHeightScrollY } from '../../../../../../shared/card/card-full-height-scroll-y'
import { NodeCaffeine } from '../../common/shared/node-caffeine'
import { FormSimpleSubmitEdit } from '../../../../../../shared/form-simple/form-submit'
import { FormSimpleText } from '../../../../../../shared/form-simple/form-text'
import { FormSimple } from '../../../../../../shared/form-simple/form'
import { FormSimpleHiddenNumber } from '../../../../../../shared/form-simple/form-hidden-number'
import { FormSimpleOrgaizationSelect } from '../../../../../../shared/form-simple/form-organization-select-filter'
import { FormSimpleCategoryOrganizationSelectFilter } from '../../../../../../shared/form-simple/form-category-organization-select-filter'
import { TransferCopyNodeStatus } from '../../../../../../shared/transfer/components/transfer-copy-node-status'
import { useTransferContext } from '../../../../../../shared/transfer/transfer-provider'
import { useTransferComplete, useTransferNodeCopyAllowGoto } from '../../../../../../shared/transfer/hooks/transfer-data'
import { useDataContext } from '../data-context'
import { pathNodeTemplate } from '../../common/shared/path-node-template'

export const NodeCourseTemplate = ({ parentURL, nodeID }) => {
  const authContext = useContext(AuthContext)

  const apiFormNodeCourse = useApiFormNodeCourse()

  const [organizationID, updateOrganizationID] = useState()

  const title = useMemo(() => `create template ${apiFormNodeCourse.form.name}`, [apiFormNodeCourse.form.name])

  useLoad(
    () => {
      authContext.state.organizationID && updateOrganizationID(authContext.state.organizationID)
    },
    [authContext.state.organizationID]
  )

  const handleMatch = () => apiFormNodeCourse.get(nodeID)

  const HeaderMenu = () => <CourseMenu place="header" url={parentURL} node={apiFormNodeCourse.form} nodeID={nodeID} />

  const handleOrgChange = value => {
    if (value) {
      updateOrganizationID(value.id)
    } else {
      updateOrganizationID(null)
    }
  }

  ///////////////

  const history = useHistory()

  const dataContext = useDataContext()
  const transferContext = useTransferContext()

  const transferID = useMemo(() => `course-to-template-${nodeID}`, [nodeID])

  const transfer = useMemo(() => transferContext.items[transferID] || null, [transferContext.items, transferID])

  const active = useMemo(() => !!transfer, [transfer])

  const allowGoto = useTransferNodeCopyAllowGoto(transfer, authContext.state.organizationID)

  useTransferComplete(transfer, () => {
    dataContext.reload()
  })

  const handleSubmit = async data => {
    if (data.destParentID === -1) {
      data.destParentID = null
    }

    const transfer = transferContext.nodeCopyCourseToTemplate(transferID, data.destName, history.location.pathname)
    transfer.start(data)
  }

  const apiListNodeTemplate = useApiListNodeTemplate()

  const handleGoTo = async nodeID => {
    let nodes = await apiListNodeTemplate.get()
    let path = pathNodeTemplate(nodes, nodeID)
    history.replace(path)
  }

  return (
    <React.Fragment>
      <BreadcrumbView Icon={IconCopy} text="create template" onMatch={handleMatch}>
        <CardFullHeightScrollY title={title} HeaderMenu={HeaderMenu}>
          <NodeCaffeine node={apiFormNodeCourse.form}>
            <FormSimple disabled={active} onSubmit={handleSubmit}>
              <FormSimpleHiddenNumber name="srcNodeID" value={nodeID} required shouldDirty />

              <LoginSysAdmin>
                <FormSimpleOrgaizationSelect name="organizationID" defaultValue={organizationID} required onChange={handleOrgChange} />
              </LoginSysAdmin>

              {organizationID &&
                <FormSimpleCategoryOrganizationSelectFilter
                  name="destParentID"
                  label="category"
                  rootName="TEMPLATE"
                  organizationID={organizationID}
                  useApiListCategory={useApiListNodeTemplateCategory}
                  required
                />}

              <FormSimpleText label="name" name="destName" defaultValue={apiFormNodeCourse.form.name} required />

              <FormSimpleSubmitEdit text="create template" backURL={parentURL} />
            </FormSimple>

            <TransferCopyNodeStatus transfer={transfer} allowGoto={allowGoto} gotoText="view new template" onGoTo={handleGoTo} />
          </NodeCaffeine>
        </CardFullHeightScrollY>
      </BreadcrumbView>
    </React.Fragment>
  )
}
